import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgPhoneNumber = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M17 1H7a2.5 2.5 0 0 0-2.5 2.5v17A2.5 2.5 0 0 0 7 23h10a2.5 2.5 0 0 0 2.5-2.5v-17A2.5 2.5 0 0 0 17 1ZM7 3h10a.5.5 0 0 1 .5.5v17a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5v-17A.5.5 0 0 1 7 3Z" />
      <path d="M13 4a1 1 0 0 1 .117 1.993L13 6h-2a1 1 0 0 1-.117-1.993L11 4h2ZM14 18a1 1 0 0 1 .117 1.993L14 20h-4a1 1 0 0 1-.117-1.993L10 18h4Z" />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgPhoneNumber)
const Memo = memo(ForwardRef)
export default Memo
